import { apiClient } from '../api-client';

export interface PlatformApiKey {
  id: string;
  apiClientId: string;
  apiClientName?: string;
  name: string;
  prefix: string;
  maskedKey: string;
  status: 'active' | 'revoked' | 'expired';
  lastUsedAt?: string;
  expiresAt?: string;
  createdAt: string;
}

// Returned exactly once by POST / rotate — plaintext key must be shown
// to the user immediately and never persisted client-side.
export interface PlatformApiKeyWithSecret extends PlatformApiKey {
  plaintextKey: string;
}

interface Envelope<T> {
  success?: boolean;
  data: T;
}

export async function listApiKeys(apiClientId: string): Promise<PlatformApiKey[]> {
  const { data } = await apiClient.get<Envelope<PlatformApiKey[] | { items: PlatformApiKey[] }>>(
    '/platform/api-keys',
    { params: { apiClientId } },
  );
  const payload = data.data;
  if (Array.isArray(payload)) return payload;
  return payload?.items ?? [];
}

export async function rotateApiKey(
  id: string,
  reason?: string,
): Promise<PlatformApiKeyWithSecret> {
  const { data } = await apiClient.post<Envelope<PlatformApiKeyWithSecret>>(
    `/platform/api-keys/${id}/rotate`,
    reason ? { reason } : {},
  );
  return data.data;
}

export async function revokeApiKey(id: string, reason?: string): Promise<void> {
  await apiClient.post(
    `/platform/api-keys/${id}/revoke`,
    reason ? { reason } : {},
  );
}
